import { css } from '@emotion/core';
import { MediaQueries } from '../../../../styles/Grid';

export const hideElement = css({
  display: 'none',
});
export const homepageSlide = css({
  '.swiper-pagination-custom': {},
  [MediaQueries.md]: {
    width: '100%',
  },

  [MediaQueries.sm]: {
    width: '100%',
  },

  width: 'calc(100% + 78px)',
  position: 'relative',

  '.shadowslide': {
    height: '320px',
    display: 'none',
    zIndex: '9',
    right: '0',
    width: '270px',
    position: 'absolute',
    background:
      'linear-gradient(270deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%)',
    [MediaQueries.sm]: {
      minHeight: '320px',
      width: '100px',
    },
  },

  // '.swiper-pagination': {
  //   display: 'none',
  //   [MediaQueries.sm]: {
  //     display: 'flex',
  //     justifyContent: 'center',
  //   },
  // },

  '.swiper-container': {
    marginLeft: '-1.666667%',
    width: '100%',
    paddingBottom: '50px',
    maxWidth: '1440px',
    [MediaQueries.sm]: {
      marginLeft: 'auto',
      width: '100%',
      paddingBottom: '0px',
    },

    '.swiper-wrapper': {
      display: 'flex',
      boxSizing: 'unset',
      [MediaQueries.sm]: {
        paddingBottom: '40px',
      },
    },
  },

  '.regus-button-prev': {
    display: 'none',
  },
  '.regus-button-next': {
    display: 'none',
  },

  '&:hover': {
    '.regus-button-prev': {
      display: 'flex',
      justifyContent: 'center',
      [MediaQueries.sm]: {
        display: 'none',
      },
    },
    '.regus-button-next': {
      display: 'flex',
      alignItems: 'center',
      [MediaQueries.sm]: {
        display: 'none',
      },
    },

    '.swiper-pagination-custom': {
      display: 'block',
    },
  },

  '.swiper-pagination-bullet-active': { opacity: 1, background: '#008385' },
  '.swiper-pagination-bullet': { margin: '0px 4px' },

  '.hiddenseperator': {
    display: 'none',
    width: '155px',
    height: '400px',
    position: 'absolute',
    left: '-25px',
    background: '#fff',
    zIndex: '1',
    top: '0px',
    [MediaQueries.xl]: {
      width: '165px',
    },
    [MediaQueries.sm]: {
      display: 'none',
    },
  },

  '.regus-button-prev': {
    position: 'absolute',
    bottom: '50%',
    alignItems: 'center',
    zIndex: 1,
    cursor: 'pointer',
    display: 'none',
    border: '0',
    outline: '0px',
    width: '48px',
    alignItems: 'center',
    justifyContent: 'center',
    height: '48px',
    borderRadius: '50%',
    boxShadow: '0px 5px 20px rgba(0, 0, 0, 0.12)',
    backgroundColor: '#fff',
    padding: '18px',
    left: '-55px',
    [MediaQueries.sm]: {
      display: 'none',
    },
    [MediaQueries.md]: {
      left: '-25px',
    },
  },

  '.regus-button-next': {
    position: 'absolute',
    bottom: '50%',
    cursor: 'pointer',
    display: 'none',
    zIndex: 1,
    width: '48px',
    boxShadow: '0px 5px 20px rgba(0, 0, 0, 0.12)',
    height: '48px',
    borderRadius: '50%',
    outline: '0px',
    border: '0',
    backgroundColor: '#fff',
    padding: '18px',
    padding: '18px',
    right: '0px',
    [MediaQueries.sm]: {
      display: 'none',
    },
    [MediaQueries.md]: {
      right: '-25px',
    },
  },
});
